// Global defines to make all headrooms consistent
export const DOWN_TOLERANCE = 20;
